import { ALL_ITEMS_PATTERN } from '../../../api/types';

export const transformSearchPattern = (pattern: string): string => {
  const specialSymbols = /[!#$%^&*()?":{}|<>]/;

  const trimmedPattern = pattern.trim();

  if (trimmedPattern.length === 0) {
    return ALL_ITEMS_PATTERN;
  }

  if (specialSymbols.test(trimmedPattern)) {
    return '';
  }

  if (trimmedPattern.includes('*')) {
    return trimmedPattern;
  }

  if (trimmedPattern.includes(' ')) {
    return `*${trimmedPattern.replace(/ /g, '\\ ')}*`;
  }

  return `*${trimmedPattern}*`;
};

export enum UserFieldNames {
  DISPLAY_NAME = 'display-name',
  UPN = 'upn',
}
